import React from 'react'
import { Layout } from 'antd'

const { Content } = Layout

export const ContentfulPageContentWrapper = ({ children }) => (
  <Content
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '24px',
    }}
  >
    {children}
  </Content>
)
